module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tempControl"
    }
  }, [_c('transition', {
    attrs: {
      "name": "sider-fade"
    }
  }, [_c('page-side', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }]
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "index-content",
    class: {
      'index-content-open': !_vm.isOpen
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('page-footer', {
    staticClass: "index-content",
    class: {
      'index-content-open': !_vm.isOpen
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-226b69d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mobileTemp/index.vue
// module id = 900
// module chunks = 1